/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Reading_File_ToastInputs */

const en_subtitle_import_reading_file_toast = /** @type {(inputs: Subtitle_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading file contents...`)
};

const fr_subtitle_import_reading_file_toast = /** @type {(inputs: Subtitle_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecture du contenu du fichier...`)
};

const de_subtitle_import_reading_file_toast = /** @type {(inputs: Subtitle_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateiinhalt wird gelesen...`)
};

const it_subtitle_import_reading_file_toast = /** @type {(inputs: Subtitle_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettura del contenuto del file...`)
};

const ru_subtitle_import_reading_file_toast = /** @type {(inputs: Subtitle_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чтение содержимого файла...`)
};

const es_subtitle_import_reading_file_toast = /** @type {(inputs: Subtitle_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leyendo el contenido del archivo...`)
};

const zh_cn2_subtitle_import_reading_file_toast = /** @type {(inputs: Subtitle_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在读取文件内容...`)
};

const ja_subtitle_import_reading_file_toast = /** @type {(inputs: Subtitle_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルの内容を読み込んでいます...`)
};

const hi_subtitle_import_reading_file_toast = /** @type {(inputs: Subtitle_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल की सामग्री पढ़ी जा रही है...`)
};

const pt_pt2_subtitle_import_reading_file_toast = /** @type {(inputs: Subtitle_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lendo o conteúdo do arquivo...`)
};

/**
* | output |
* | --- |
* | "Reading file contents..." |
*
* @param {Subtitle_Import_Reading_File_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_reading_file_toast = /** @type {((inputs?: Subtitle_Import_Reading_File_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Reading_File_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_reading_file_toast(inputs)
	if (locale === "de") return de_subtitle_import_reading_file_toast(inputs)
	if (locale === "it") return it_subtitle_import_reading_file_toast(inputs)
	if (locale === "ru") return ru_subtitle_import_reading_file_toast(inputs)
	if (locale === "es") return es_subtitle_import_reading_file_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_reading_file_toast(inputs)
	if (locale === "ja") return ja_subtitle_import_reading_file_toast(inputs)
	if (locale === "hi") return hi_subtitle_import_reading_file_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_reading_file_toast(inputs)
	return en_subtitle_import_reading_file_toast(inputs)
});